import { createSelector } from 'reselect'

import { selectConfigurationState } from './selectConfigurationState'

export const selectRtm = createSelector([selectConfigurationState], ({ data }) => data.rtm)
